import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "opcoes-avancadas__titulo" }
const _hoisted_4 = { class: "opcoes-avancadas__opcao" }
const _hoisted_5 = { class: "opcoes-avancadas__descricao" }
const _hoisted_6 = { class: "opcoes-avancadas__opcao" }
const _hoisted_7 = { class: "opcoes-avancadas__descricao" }
const _hoisted_8 = { class: "opcoes-avancadas__aviso" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "raiz",
    class: "opcoes-avancadas",
    "data-assistente-ignorar": "",
    onKeydown: _withKeys(_withModifiers($setup.fechar, ["stop","prevent"]), ["esc"])
  }, [
    _createCommentVNode("\n      Discreto de propósito: é ferramenta de teste, ligada por variável de\n      ambiente no agente. Quem não testa nem chega a ver (o dock só monta\n      este componente com `opcoes.exibir`).\n    "),
    _createVNode($setup["PontotelBotaoIcone"], {
      "data-testid": "assistente-dock-opcoes-avancadas",
      tamanho: "P",
      tipo: "neutro",
      peso: "intermediario",
      "aria-label": $setup.t('assistentePontotel.opcoesAvancadas.abrir'),
      title: $setup.t('assistentePontotel.opcoesAvancadas.abrir'),
      "aria-expanded": $setup.aberto,
      "aria-controls": $setup.idDoPopover,
      onClique: $setup.alternar
    }, {
      icone: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            d: "M4 7h10M18 7h2M4 17h4M12 17h8",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }),
          _createElementVNode("circle", {
            cx: "16",
            cy: "7",
            r: "2",
            stroke: "currentColor",
            "stroke-width": "2"
          }),
          _createElementVNode("circle", {
            cx: "10",
            cy: "17",
            r: "2",
            stroke: "currentColor",
            "stroke-width": "2"
          })
        ], -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["aria-label", "title", "aria-expanded"]),
    ($setup.aberto)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: $setup.idDoPopover,
          ref: "popover",
          class: "opcoes-avancadas__popover",
          style: _normalizeStyle($setup.estiloDoPopover),
          role: "dialog",
          "aria-label": $setup.t('assistentePontotel.opcoesAvancadas.titulo'),
          "data-testid": "opcoes-avancadas-popover"
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString($setup.t('assistentePontotel.opcoesAvancadas.titulo')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["PontotelToggle"], {
              "data-testid": "opcoes-avancadas-tela",
              tamanho: "M",
              "model-value": $props.opcoes.acoesDeTela,
              label: $setup.t('assistentePontotel.opcoesAvancadas.acoesDeTela'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.mudar('tela', $event)))
            }, null, 8 /* PROPS */, ["model-value", "label"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString($setup.t('assistentePontotel.opcoesAvancadas.acoesDeTelaDescricao')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["PontotelToggle"], {
              "data-testid": "opcoes-avancadas-sistema",
              tamanho: "M",
              "model-value": $props.opcoes.acoesDeSistema,
              label: $setup.t('assistentePontotel.opcoesAvancadas.acoesDeSistema'),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.mudar('sistema', $event)))
            }, null, 8 /* PROPS */, ["model-value", "label"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString($setup.t('assistentePontotel.opcoesAvancadas.acoesDeSistemaDescricao')), 1 /* TEXT */)
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString($setup.t('assistentePontotel.opcoesAvancadas.aviso')), 1 /* TEXT */)
        ], 12 /* STYLE, PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true)
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}